import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import styled from "@mui/material/styles/styled";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UHF_BRAND, headCells } from "./data";
import config from "../../../assests/config";
import { Row } from "./index";
const StyleGridBodyWrapper = styled(Grid)(({ theme }) => {
    return {};
});
const ResponsiveMyShare = ({ data, brand }) => {
    const [panel, setPanel] = useState("");
    const isUHFBrand = React.useMemo(() => {
        return brand.toLowerCase() === config.uhf;
    }, [brand]);
    const headings = !isUHFBrand ? UHF_BRAND.headCells : [...headCells];
    const changePannel = (selected, panel) => {
        setPanel(selected === panel ? "" : selected);
    };
    return (React.createElement(StyleGridBodyWrapper, null,
        data.map((idData, i) => {
            return (React.createElement(Accordion, { expanded: panel === "panel" + i, className: "my-share-accordioan-transaction", onChange: () => changePannel("panel" + i, panel) },
                React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), "aria-controls": "panel1a-content", id: "panel1a-header" },
                    React.createElement(Grid, { container: true }, headings
                        .filter(({ label }) => label)
                        .map((val) => {
                        return (React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement("label", { className: "Expense-Number221" }, val.label),
                            React.createElement("p", { className: "Expense-Number211" },
                                React.createElement("span", { className: ` ${val.id === "status"
                                        ? "status_field status-field_" +
                                            idData[val.id].toLowerCase()
                                        : null}` }, idData.data[val.id]))));
                    }))),
                React.createElement(AccordionDetails, null,
                    React.createElement(Grid, { container: true },
                        React.createElement(Row, { key: "summary " + i, row: idData, brand: brand }),
                        ";"))));
        }),
        (brand === null || brand === void 0 ? void 0 : brand.toLowerCase()) === config.uhf ? (React.createElement("p", { className: "eos-text" }, "** For complete status, please refer to the Explanation of Sharing (EOS) mailed to your address on file")) : null));
};
export default ResponsiveMyShare;
